// src/components/CoreAssure/Readiness/ReadinessCategoryGrid.js
//
// CoreAssure ReadyCore — 6-category grid + blockers list.
// Each category card is PASS (green checkmark) or FAIL (red x) with
// blocker count + detail. Blockers list at the bottom is the actionable
// drill-down.

import React from "react";
import {
  Card, CardContent, Grid, Typography, Box, Stack, Chip, Button, List, ListItem, ListItemText,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const CATEGORY_FIX_LINK = {
  drawings:    { label: "Open Documents",     to: "/documents" },
  materials:   { label: "Open Heat Manager",  to: "/heat-management" },
  personnel:   { label: "Open Welders",       to: "/welders" },
  calibration: { label: "Open Calibration",   to: "/calibration" },
  tooling:     { label: "Open Calibration",   to: "/calibration" },
  procedures:  { label: "Open Tasks",         to: "/tasks" },
};

export default function ReadinessCategoryGrid({ score, navigate }) {
  if (!score || !Array.isArray(score.categoryResults)) return null;

  return (
    <Stack spacing={2}>
      <Grid container spacing={2}>
        {score.categoryResults.map((cat) => {
          const passed = !!cat.passed;
          return (
            <Grid item xs={12} sm={6} md={4} key={cat.category}>
              <Card variant="outlined" sx={{
                borderColor: passed ? "success.light" : "error.light",
                bgcolor: passed ? "success.50" : "error.50",
              }}>
                <CardContent sx={{ pb: "12px !important" }}>
                  <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
                    {passed ? (
                      <CheckCircleOutlineIcon color="success" fontSize="small" />
                    ) : (
                      <HighlightOffIcon color="error" fontSize="small" />
                    )}
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                      {cat.label || cat.category}
                    </Typography>
                  </Stack>
                  <Typography variant="caption" color="text.secondary">
                    {cat.detail || (passed ? "Pass" : "Fail")}
                  </Typography>
                  {!passed && cat.blockerCount > 0 && (
                    <Box sx={{ mt: 1 }}>
                      <Chip
                        label={`${cat.blockerCount} blocker${cat.blockerCount === 1 ? "" : "s"}`}
                        size="small"
                        color="error"
                        variant="outlined"
                      />
                    </Box>
                  )}
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>

      {Array.isArray(score.blockers) && score.blockers.length > 0 && (
        <Card variant="outlined">
          <CardContent>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>
              Blockers ({score.blockers.length})
            </Typography>
            <List dense>
              {score.blockers.map((b, i) => {
                const fix = CATEGORY_FIX_LINK[b.category];
                return (
                  <ListItem
                    key={i}
                    secondaryAction={fix ? (
                      <Button size="small" onClick={() => navigate && navigate(fix.to)}>
                        {fix.label}
                      </Button>
                    ) : null}
                  >
                    <ListItemText
                      primary={b.reason}
                      secondary={`Category: ${b.category}`}
                    />
                  </ListItem>
                );
              })}
            </List>
          </CardContent>
        </Card>
      )}
    </Stack>
  );
}
